class SelectRadioOnFocus {

    constructor(el) {
        this.el = el;
        this.targetRadio = document.querySelector(this.el.dataset.targetRadio);
        if(this.targetRadio != null) {
            this.siblings = document.querySelectorAll(`input[type="radio"][name="${this.targetRadio.getAttribute('name')}"]:not(#${this.targetRadio.getAttribute('id')})`);
            // add listeners
            this.el.addEventListener('focus', () => {
                if(!this.targetRadio.checked) {
                    this.targetRadio.checked = true;
                    this.targetRadio.setAttribute('checked',true);
                    this.el.setAttribute('required',true);
                    this.siblings.forEach(s => {
                        s.checked = false;
                        s.removeAttribute('checked');
                    });
                }
            });
            this.siblings.forEach(s => {
                s.addEventListener('click', () => {
                    this.el.value = '';
                    this.el.removeAttribute('required');
                });
            });
        }
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new SelectRadioOnFocus(node);
        }
    });
}